import { useNavigate } from 'react-router'
import PropTypes from 'prop-types'
import { ChatCircleText, Lock } from '@phosphor-icons/react'
import { useTranslation } from 'react-i18next'

const ActivateSmsCard = () => {
  const { t } = useTranslation(['organisation'])
  const navigate = useNavigate()
  return (
    <div className="analytics-card">
      <h2 className="analytics-card__title">
        <ChatCircleText size={25} />
        {t('organisation:communicationPortal.activateSmsCard.smsTitle')}
      </h2>
      <div className="analytics-card__blocked-message-container">
        <Lock size={25} weight="fill" />
        <h3>{t('organisation:communicationPortal.activateSmsCard.title')}</h3>
        <p>{t('organisation:communicationPortal.activateSmsCard.description')}</p>
        <button className="button button-gray" onClick={() => navigate('/dashboard/chat')}>
          {t('organisation:communicationPortal.activateSmsCard.activateNow')}
        </button>
      </div>
    </div>
  )
}

ActivateSmsCard.propTypes = {
  router: PropTypes.object,
}

export default ActivateSmsCard
